import { isEmpty } from 'ramda';

enum BrandTypename {
  BrandAssetVenmoIcon = 'BrandAssetVenmoIcon',
  BrandAssetVenmoTile = 'BrandAssetVenmoTile',
  BrandAssetVenmoBackground = 'BrandAssetVenmoBackground',
  BrandAssetVenmoNote = 'BrandAssetVenmoNote',
  BrandAssetMerchantName = 'BrandAssetMerchantName',
  BrandAssetCard = 'BrandAssetCard',
  BrandAssetIcon = 'BrandAssetIcon',
  BrandAssetBanner = 'BrandAssetBanner',
  BrandAssetFeaturedBanner = 'BrandAssetFeaturedBanner',
  BrandAssetFeaturedBannerHeadline = 'BrandAssetFeaturedBannerHeadline',
  BrandAssetPrimaryColor = 'BrandAssetPrimaryColor',
  BrandAssetSecondaryColor = 'BrandAssetSecondaryColor',
}

enum BrandAssetComponent {
  background = 'background',
  icon = 'icon',
  tile = 'tile',
  venmoNote = 'venmoNote',
  venmoNoteQRC = 'venmoNoteQRC',
  merchantName = 'merchantName',
  cardImage = 'cardImage',
  banner = 'banner',
  featuredBanner = 'featuredBanner',
  featuredBannerHeadline = 'featuredBannerHeadline',
  primaryColor = 'primaryColor',
  secondaryColor = 'secondaryColor',
}

type ImageInfo = {
  id: string;
  batchId: string;
  asset_id: string;
  public_id: string;
  version: string;
  version_id: string;
  signature: string;
  width: number;
  height: number;
  format: string;
  resource_type: string;
  created_at: string;
  tags: string[];
  bytes: number;
  type: string;
  etag: string;
  placeholder: boolean;
  url: string;
  secure_url: string;
  access_mode: string;
  existing: boolean;
  original_filename: string;
  original_extension: string;
  path: string;
  thumbnail_url: string;
};

type MerchantDetails = {
  merchantUuid: string;
  merchantName: string;
  description: string;
  logo: string;
  banner?: string;
  card?: string;
  primaryColor?: string;
  secondaryColor?: string;
  brandMatchers?: string[];
  placesMatchers?: string[];
  category?: string;
  subCategory?: string;
};

const getImageDetails = (imageInfo: string) => {
  if (imageInfo === '') {
    return {
      width: 0,
      height: 0,
      format: '',
      path: '',
      publicId: '',
    };
  }

  const { secure_url, public_id, width, height, format } = JSON.parse(
    imageInfo,
  );

  return {
    width,
    height,
    format,
    path: secure_url,
    publicId: public_id,
  };
};

const buildBrandAssetImage = (
  imageInfo: string | undefined,
  type: string,
  component: BrandAssetComponent,
  typename: BrandTypename,
) => {
  if (imageInfo === '' || imageInfo === undefined) {
    return {};
  }

  const { secure_url, width, height, format } = JSON.parse(imageInfo);

  return {
    component,
    type,
    format,
    width,
    height,
    path: secure_url,
    __typename: typename,
  };
};

const buildBrandAssetColor = (
  value: string | undefined,
  type: string,
  component: BrandAssetComponent,
  typename: BrandTypename,
) => ({
  component,
  type,
  value,
  version: '1.0.0',
  __typename: typename,
});

const buildBundleComponent = (
  value: string | undefined,
  type: string,
  component: BrandAssetComponent,
  typename: BrandTypename,
) => {
  if (value === '' || value === undefined) {
    return {};
  }

  return {
    component,
    type,
    value,
    __typename: typename,
  };
};

const buildMatchers = (matchers: string[] = []) => {
  const newMatchers = matchers.map((matcher: string) => {
    if (!matcher || isEmpty(matcher)) return null;
    return {
      type: 'REGEX',
      pattern: matcher,
      options: 'i',
    };
  });
  return newMatchers.filter((matcher) => matcher != null);
};

export {
  getImageDetails,
  buildBrandAssetImage,
  buildBrandAssetColor,
  buildMatchers,
  buildBundleComponent,
  MerchantDetails,
  BrandTypename,
  BrandAssetComponent,
  ImageInfo,
};
